import { useQuery } from '@tanstack/react-query'
import {
  CORE_SHELL_MESSAGE_REQUESTS, CORE_SHELL_MESSAGE_SOURCES,
  resolveLocalizationContext, sourceLocalizationContext, type LocalizationContext,
} from '@solum/experience'
import { LocalizationProvider } from '@solum/ui'
import { useAuth } from '@solum/auth'
import type { ReactNode } from 'react'
import { useSolum } from '../data/client'

export const LOCALIZATION_QUERY_KEY = ['localization', 'shell'] as const

export function ConsoleLocalization({ children }: { children: ReactNode }) {
  const { session } = useAuth()
  const { client, isLive } = useSolum()
  const query = useQuery({
    queryKey: [...LOCALIZATION_QUERY_KEY, session?.user.id ?? 'fixture'],
    enabled: !isLive || Boolean(session),
    queryFn: async (): Promise<LocalizationContext> => {
      if (!isLive) return sourceLocalizationContext()
      // The shell outgrew one resolver call (74 messages, limit 64): batch it
      // through the same path the Portal uses (MB-SOLUM #1863 c.124186).
      return resolveLocalizationContext((batch) => client.resolveMessageContext(batch), CORE_SHELL_MESSAGE_REQUESTS)
    },
  })
  const state = query.isError ? 'error' : query.data ? 'ready' : 'loading'
  return <LocalizationProvider context={query.data} state={state}
    sourceMessages={CORE_SHELL_MESSAGE_SOURCES} retry={() => { void query.refetch() }}>
    {children}
  </LocalizationProvider>
}
